// extracted by mini-css-extract-plugin
export default {"wrapper":"modal_wrapper__iY+8O","open":"modal_open__eN4w7","modal":"modal_modal__OrC6l","close":"modal_close__QTM7Z"};